import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { UserIcon, UsersIcon, CheckCircle2Icon } from 'lucide-react';
export function ResultsSection() {
  const forYou = [{
    text: 'Seguridad absoluta',
    highlight: ' para responder cada "¿por qué?"'
  }, {
    text: 'Ahorro de horas',
    highlight: ' en planificación'
  }, {
    text: 'Autoridad profesional',
    highlight: ''
  }];
  const forStudents = [{
    text: 'Resultados más rápidos',
    highlight: ' con técnica perfecta'
  }, {
    text: 'Confianza total',
    highlight: ' en tu trabajo'
  }, {
    text: 'Prevención real',
    highlight: ' de lesiones'
  }];
  return <section className="py-10 relative overflow-hidden bg-background" data-id="element-267">
      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-268">
        <FadeIn className="text-center mb-10" data-id="element-269">
          <h2 className="text-3xl md:text-4xl font-black mb-4 text-gray-900" data-id="element-270">
            Lo que vas a lograr{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary" data-id="element-271">
              vos y tus alumnos
            </span>
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-272">
          <FadeIn delay={0.2} direction="up" data-id="element-273">
            <div className="bg-primary/5 border border-primary/20 rounded-2xl p-6 h-full" data-id="element-274">
              <div className="flex items-center gap-3 mb-4" data-id="element-275">
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center" data-id="element-276">
                  <UserIcon className="w-5 h-5 text-primary" data-id="element-277" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-278">Para Vos</h3>
              </div>
              <ul className="space-y-3" data-id="element-279">
                {forYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-280">
                    <CheckCircle2Icon className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-281" />
                    <span className="text-gray-600" data-id="element-282">
                      <span className="text-gray-900 font-semibold" data-id="element-283">
                        {item.text}
                      </span>
                      {item.highlight}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} direction="up" data-id="element-284">
            <div className="bg-green-50 border border-green-200 rounded-2xl p-6 h-full" data-id="element-285">
              <div className="flex items-center gap-3 mb-4" data-id="element-286">
                <div className="w-10 h-10 rounded-xl bg-green-100 flex items-center justify-center" data-id="element-287">
                  <UsersIcon className="w-5 h-5 text-green-600" data-id="element-288" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-289">
                  Para Tus Alumnos
                </h3>
              </div>
              <ul className="space-y-3" data-id="element-290">
                {forStudents.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-291">
                    <CheckCircle2Icon className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-292" />
                    <span className="text-gray-600" data-id="element-293">
                      <span className="text-gray-900 font-semibold" data-id="element-294">
                        {item.text}
                      </span>
                      {item.highlight}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}